import React from "react";
import { useTranslation } from "react-i18next";
import Section from "../components/Section";
import SectionHeading from "../components/SectionHeading";
import StatCard from "../components/StatCard";
import { SECTION_IDS } from "../landingConfig";

/**
 * Pilot results. Every figure here must match the approved numbers exactly.
 *
 * NOTE: there is no testimonial block. No attributable, cleared quote exists
 * yet, and inventing one on a page about children's mental health is not an
 * option. When a real quote is cleared (name + role + school, in writing), it
 * belongs directly under this stat row.
 */
const STATS = ["schools", "students", "tests", "flagged"];

export default function Traction() {
  const { t } = useTranslation();

  return (
    <Section id={SECTION_IDS.results}>
      <SectionHeading
        eyebrow={t("landing.traction.eyebrow")}
        title={t("landing.traction.h2")}
      />
      {/*
        4-across only from xl. At lg the cells are ~216px, which is too narrow
        for the longest value in English ("600 → ~10,000") and wraps just that
        one stat out of line with the rest of the row.
      */}
      <dl className="mt-12 grid gap-8 sm:grid-cols-2 xl:grid-cols-4">
        {STATS.map((key, i) => (
          <StatCard
            key={key}
            index={i}
            value={t(`landing.traction.${key}_value`)}
            label={t(`landing.traction.${key}_label`)}
          />
        ))}
      </dl>
    </Section>
  );
}
